import types from './types';
import { commonReducer, lciCRUDReducer, lciDataReducer, supportingReducer, lciMonitoringReducer } from './states';
import { combineReducer } from '../../utilities/combineUseReducer';

const reducers = {};
[commonReducer, lciCRUDReducer, lciDataReducer, supportingReducer, lciMonitoringReducer].map(r => {
  reducers[r.stateKey] = r.reducer;
});

const reducer = combineReducer(reducers);

export { reducer, types };
